import { FC, Dispatch, SetStateAction } from "react";
import Descriptions from "./LaborCategoryDescriptions.json";

interface IDescription {
  position: string;
  experience: string;
  responsibility: string;
  education: string;
  division: string;
  gsa_price: number;
}

interface ICollapsables {
  information_for_ordering_offices: boolean;
  terms_and_conditions: boolean;
  labor_category_descriptions: boolean;
  labor_rates: boolean;
}

interface IProps {
  isCollapsed: ICollapsables;
  setIsCollapsed: Dispatch<SetStateAction<ICollapsables>>;
}

export const LaborCategoryDescriptions: FC<IProps> = ({
  isCollapsed,
  setIsCollapsed,
}) => {
  let laborDescriptions: IDescription[] = Descriptions.labor_categories;
  return (
    <div className="Contract__wrapper__section">
      <h2
        onClick={() =>
          setIsCollapsed({
            ...isCollapsed,
            labor_category_descriptions: !isCollapsed.labor_category_descriptions,
          })
        }
        className="collapsable"
      >
        Labor Category Descriptions
        <i
          className={
            isCollapsed.labor_category_descriptions
              ? "fas fa-caret-down"
              : "fas fa-caret-up"
          }
        ></i>
      </h2>
      <div
        className={`Contract__wrapper__section__content ${
          isCollapsed.labor_category_descriptions ? "hidden" : ""
        }`}
      >
        <div className="collapse-wrapper">
          <button
            onClick={() =>
              setIsCollapsed({
                ...isCollapsed,
                labor_category_descriptions: true,
              })
            }
            className="collapse-section"
          >
            Collapse section
          </button>
        </div>
        <div className="general_info">
          <span>GSA Contract Number - GS-35F-068GA</span>
          <span>Professional Software Engineering, Inc. (t/a PROSOFT)</span>
          <div className="general_info__contact">
            <span>500 Viking Drive, Suite 301</span>
            <span>Virginia Beach, VA 23452-7477</span>
            <span>(757) 431-2400</span>
          </div>
          <span className="general_info__subheader">
            SERVICES SKILL CATEGORY DESCRIPTIONS
          </span>
        </div>
        <div className="notice">
          <ol>
            {laborDescriptions.map((desc: IDescription) => {
              return (
                <>
                  <li className="bold">{desc.position}</li>
                  <p>
                    <span className="labor-span">
                      Minimum General Experience:
                    </span>{" "}
                    {desc.experience}
                  </p>
                  <p>
                    <span className="labor-span">
                      Functional Responsibility:
                    </span>{" "}
                    {desc.responsibility}
                  </p>
                  <p>
                    <span className="labor-span">Education: </span>{" "}
                    {desc.education}
                  </p>
                </>
              );
            })}
          </ol>
        </div>
      </div>
    </div>
  );
};
